@if(dataVisible$ | async) {
  <form [formGroup]="formGroup">
    <div class="row" formGroupName="opbouwInkomen">
      <div class="col col-1">
        <p>Grondslag sparen en beleggen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="grondslagSparenEnBeleggen"
          id="grondslagSparenEnBeleggen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    @if(formGroup.controls.opbouwInkomen.controls.grondslagNaVerdeling) {
      <div class="row" formGroupName="opbouwInkomen">
        <div class="col col-1">
          Aandeel in grondslag sparen en beleggen
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="grondslagNaVerdeling"
            id="grondslagNaVerdeling"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    <div class="row">
      <div class="col col-1">
        <p>Forfaitair rendement uit sparen en beleggen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="toegepasteRendement"
          id="inkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    @if(heeftOwr) {
      <div class="row">
        <div class="col col-1">
          <p>Werkelijk inkomen uit sparen en beleggen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="werkelijkRendement"
            id="werkelijkRendement"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
      <div class="row">
        <div class="col col-1">
          <p>Toegepaste inkomen uit sparen en beleggen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control
            [decimals]="0"
            align="right"
            class="custom-input-150"
            formControlName="toegepasteRendement"
            id="toegepasteRendement"
            prefix="€"
          ></snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }
    @let gronslagNaVerdeling = formGroup.controls.opbouwInkomen.controls.grondslagNaVerdeling.value ?? 0;
    @let grondslag = formGroup.controls.opbouwInkomen.controls.grondslagSparenEnBeleggen.value ?? 0;
    @let rendement = formGroup.controls.toegepasteRendement.value ?? 0;

    <div class="row">
      <div class="col col-1">
        @if(formGroup.controls.opbouwInkomen.controls.grondslagNaVerdeling.value ?? 0) {
          <p>Inkomen uit sparen en beleggen (€ {{ gronslagNaVerdeling | number:'1.0-0':'nl-NL' }} / € {{ grondslag | number:'1.0-0':'nl-NL' }}) * € {{ rendement | number:'1.0-0':'nl-NL' }}</p>
        } @else {
          <p>Inkomen uit sparen en beleggen</p>
        }
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="inkomen"
          id="inkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        Verrekende persoonsgebonden aftrek
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="persoonsgebondenAftrek"
          id="persoonsgebondenAftrek"
          prefix="€ -"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
    <div class="row">
      <div class="col col-1">
        <b>Belastbaar inkomen uit sparen en beleggen {{ isPartnerView ? 'partner' : 'aangever' }}</b>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="belastbaarInkomen"
          id="belastbaarInkomen"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
  </form>
}
